const locale = {
  APP_TITLE: 'Mailbox',
  COMPOSE: 'Compose',
  FOLDERS: 'Mailboxes',
  FILTERS: 'Filters',
  LABELS: 'Labels',
  NO_MESSAGES: 'There are no messages!',
  SEARCH_PLACEHOLDER: 'Search for an e-mail or task',
  INBOX: 'Inbox',
  SENT: 'Sent',
  DRAFTS: 'Drafts',
  SPAM: 'Spam',
  TRASH: 'Trash',
  STARRED: 'Starred',
  IMPORTANT: 'Important',
};

export default locale;
